import { useSelector } from "react-redux";
import WarpText from "../../components/WarpText";

/* The dashboards' page title: "Welcome, <first name>" in place of the plain
   "Dashboard", drawn through WarpText's glass lens. It reads as ordinary
   text, with no entrance, until the pointer is over it; then it bends around
   the pointer and ripples on click, and settles flat again on the way out.

   Same size, weight and tracking as .page-title, flush left. The canvas box
   is a little taller than the title's line (WarpText fits text into 78% of
   its height), and .page-title-warp pulls the margins in by the difference
   so the head keeps its rhythm. WarpText inks the text in the container's
   colour and re-reads it every few frames, so a theme flip needs nothing
   here. This replaces the shell's one-line "Welcome Back" greeting on the
   dashboard (components/Sidebar.js hides it there). */
const WelcomeHeadline = () => {
  const user = useSelector((state) => state.signinReducers)?.data;
  const name = (user?.first_name ?? "").trim();

  return (
    <h1 className="page-title page-title-warp">
      <WarpText
        text={name ? `Welcome, ${name}` : "Welcome"}
        align="left"
        hoverOnly
        warpStrength={0.08}
        warpScale={1.7}
        speed={0.55}
        lens="bulge"
        pointerInfluence={0.6}
        pointerStrength={0.38}
        refraction={0.01}
        chromatic={0.2}
        idleDrift={0}
        ripple
        clickRipple
        intro={false}
        fontSize={30}
        fontWeight={700}
        letterSpacing="-0.02em"
        lineHeight={1.15}
        style={{ height: 48, minHeight: 0 }}
      />
    </h1>
  );
};

export default WelcomeHeadline;
